<template>
  <div class="barcode-scanner">
    <video ref="video" class="barcode-scanner-video" playsinline muted />
  </div>
</template>

<script>
import { BrowserMultiFormatReader } from '@zxing/library'

export default {
  name: 'BarcodeScanner',
  data () {
    return {
      codeReader: null,
      hasDecoded: false
    }
  },
  mounted () {
    this.startScanner()
  },
  beforeDestroy () {
    this.stopScanner()
  },
  methods: {
    startScanner () {
      this.codeReader = new BrowserMultiFormatReader()
      this.codeReader.decodeFromVideoDevice(undefined, this.$refs.video, (result) => {
        if (result && !this.hasDecoded) {
          this.hasDecoded = true
          this.stopScanner()
          this.$emit('barcodeRead', result.getText())
        }
      })
    },
    stopScanner () {
      if (this.codeReader) {
        this.codeReader.reset()
        this.codeReader = null
      }

      const video = this.$refs.video
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop())
        video.srcObject = null
      }
    }
  }
}
</script>

<style lang="scss">
.barcode-scanner {
  width: 100%;

  &-video {
    display: block;
    width: 100%;
    max-height: 60vh;
    object-fit: cover;
    background-color: $black;
  }
}
</style>
